(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["media"] && !Shopify.designMode) return;
  try {
    /* LOCAL EDIT 2026-09-29: PDP hero videos (see the comment above the
     <video>). preload="none" keeps them off the network until they are
     near the viewport; they play only while visible and never under
     reduced motion, where the poster stands in. */
  (() => {
    const videos = document.querySelectorAll('video[data-bb-hero-video]');
    if (!videos.length || !('IntersectionObserver' in window)) return;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    const observer = new IntersectionObserver(
      (entries) => {
        for (const { target, isIntersecting } of entries) {
          if (isIntersecting && !reduce.matches) {
            target.play().catch(() => {});
          } else {
            target.pause();
          }
        }
      },
      { rootMargin: '200px 0px' }
    );
    videos.forEach((video) => observer.observe(video));
  })();
  } catch(e) { console.error(e); }
})();

})();
